module.exports = __webpack_public_path__ + "static/media/cherry3.c2650c78.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/svg/cherry3.svg
// module id = 1396
// module chunks = 0